import { faArrowLeft, faBars, faBell, faCaretDown, faCircle, faCircleUser } from '@fortawesome/pro-solid-svg-icons';
import { withTheme } from '@emotion/react';
import PropTypes from 'prop-types';
import React, { useEffect, useState, useRef } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { toggleMultiNotifsMenu, toggleOptionsMenu } from '../../actions/menus';
import { startLoadingNotificationsByUser } from '../../actions/notification';
import { changePage } from '../../actions/project';
import { animationDelay } from '../../constants/styles';
import useWindowSize from '../../hooks/useWindowSize';
import { projectPageSelector, projectSelector, userSelector, isBtoBSelector, isInitialisationTerrealSelector, isTerrealCustomerSelector } from '../../selectors';
import { notifSelector } from '../../selectors/notification';
import IndexProImage from '../../static/algar-pro-logo-white.svg';
import IndexTerrealImage from '../../static/terreal.svg';
import IndexImage from '../../static/algar-logo-white.svg';
import MultiNotifsMenuContainer from '../container-multi-notifs-menu';
import { IconContainer } from '../container-multi-notifs-menu/styled';
import NotificationsContainerOverlay from '../container-notification-overly';
import { closeNotifOverlayAnimation, openNotifOverlayAnimation } from '../container-notification-overly/styled';
import SidebarContainerOverlay from '../container-sidebar-overly';
import { closeBurgerMenuAnimation, openBurgerMenuAnimation } from '../container-sidebar-overly/styled';
import useOnClickOutside from '../../hooks/useClickOutside';
import { HeaderContent, HeaderHeadlineWrapper, HeaderIcon, HeaderSvgContainer, LogoWrapper, NotifContainer, ProjectHeader, RedPointIcon, Title, TitleWrapper, UserAccount, UserAccountMenu, UserAccountMenuItem, UserAccountMenuContent, UserArrow, UserAvatar, UserContent, UserMenuContainer, UserAccountMenuTitle } from './styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLockKeyhole, faArrowRightFromBracket } from '@fortawesome/pro-regular-svg-icons';
import { setChangePasswordOverlay } from '../../actions/overlay';
const getAvatarUrl = props => [window.processRuntime.env?.API_URL, 'v1', 'workers', props.facilitator ? props.facilitator.id : props.seller.id, 'avatar'].join('/');
const ProjectHeaderView = props => {
  const history = useHistory();
  const dispatch = useDispatch();
  const refUserMenu = useRef(null);
  const {
    isTabletOrMobile,
    isMobile
  } = useWindowSize();
  const {
    location: {
      pathname
    }
  } = useHistory();
  const user = useSelector(userSelector);
  const isBtoB = useSelector(isBtoBSelector);
  const isTerrealCustomer = useSelector(isTerrealCustomerSelector);
  const isInitialisationTerreal = useSelector(isInitialisationTerrealSelector);
  const [homeIcon, setHomeIcon] = useState('');
  const [imageStyle, setImageStyle] = useState({});
  useEffect(() => {
    if (isBtoB) {
      if (isTerrealCustomer) {
        setHomeIcon(IndexTerrealImage);
        setImageStyle({
          transform: 'scale(1.8)',
          marginLeft: isMobile ? '0px' : '25px'
        });
      } else {
        setHomeIcon(IndexProImage);
        setImageStyle({
          transform: 'scale(1)'
        });
      }
    } else {
      setHomeIcon(IndexImage);
      setImageStyle({
        transform: 'scale(1)'
      });
    }
  }, [isBtoB, isInitialisationTerreal, isTerrealCustomer, isMobile]);
  const {
    userNotifications,
    userNotificationsLoading,
    userNotificationsError
  } = useSelector(notifSelector);
  const projectPage = useSelector(projectPageSelector);
  const {
    selectedProjectFacilitator,
    selectedProjectSeller
  } = useSelector(projectSelector);
  const [openBurgerMenuOverlay, setOpenBurgerMenuOverlay] = useState(false);
  const [openNotificationOverlay, setOpenNotificationOverlay] = useState(false);
  const [burgerMenuAnimation, setBurgerMenuAnimation] = useState(openBurgerMenuAnimation);
  const [notifOverlayAnimation, setNotifOverlayAnimation] = useState(openNotifOverlayAnimation);
  const [openUserAccount, setOpenUserAccount] = useState(false);
  const isCreateProjectPage = projectPage === 'page-create-new-project';
  const isHasUnreadNotif = userNotifications?.find(notif => !notif.isRead) || false;
  useOnClickOutside(refUserMenu, () => setOpenUserAccount(false), 'userAccountBtn');

  // Get userNotifications
  useEffect(() => {
    if (user && user.profile && !userNotifications && !userNotificationsLoading && !userNotificationsError) {
      dispatch(startLoadingNotificationsByUser(user, {
        limit: 15,
        offset: 0
      }));
    }
  }, [user, userNotifications, userNotificationsLoading, userNotificationsError]);
  const handleOpenBurgerMenu = () => {
    setBurgerMenuAnimation(openBurgerMenuAnimation);
    setOpenBurgerMenuOverlay(true);
  };
  const handleCloseBurgerMenu = () => {
    setBurgerMenuAnimation(closeBurgerMenuAnimation);
    setTimeout(() => {
      setOpenBurgerMenuOverlay(false);
    }, animationDelay * 1000);
  };
  const handleOpenNotificationOverlay = () => {
    setNotifOverlayAnimation(openNotifOverlayAnimation);
    setOpenNotificationOverlay(true);
  };
  const handleCloseNotificationOverlay = () => {
    setNotifOverlayAnimation(closeNotifOverlayAnimation);
    setTimeout(() => {
      setOpenNotificationOverlay(false);
    }, animationDelay * 1000);
  };
  const onClickArrowLeft = () => {
    dispatch(changePage('switch'));
  };
  const handleClickChangePassword = () => {
    setOpenUserAccount(false);
    dispatch(setChangePasswordOverlay());
  };
  const handleLogout = () => {
    setOpenUserAccount(false);
    history.push('/logout');
  };
  return /*#__PURE__*/React.createElement(ProjectHeader, {
    pathname: pathname
  }, /*#__PURE__*/React.createElement(HeaderContent, null, /*#__PURE__*/React.createElement(HeaderHeadlineWrapper, null, isTabletOrMobile && (isCreateProjectPage ? /*#__PURE__*/React.createElement(IconContainer, {
    onClick: onClickArrowLeft
  }, /*#__PURE__*/React.createElement(HeaderIcon, {
    size: "3x",
    icon: faArrowLeft
  })) : /*#__PURE__*/React.createElement(IconContainer, {
    onClick: handleOpenBurgerMenu
  }, /*#__PURE__*/React.createElement(HeaderIcon, {
    size: "3x",
    icon: faBars
  }))), homeIcon !== '' && /*#__PURE__*/React.createElement(LogoWrapper, {
    href: window.processRuntime.env?.HP_BASE_URL,
    title: "Algar.co",
    isbtob: isBtoB
  }, /*#__PURE__*/React.createElement("img", {
    src: homeIcon,
    style: imageStyle,
    alt: "accueil"
  }))), /*#__PURE__*/React.createElement(UserContent, null, /*#__PURE__*/React.createElement(NotifContainer, null, isTabletOrMobile ? /*#__PURE__*/React.createElement(IconContainer, {
    onClick: handleOpenNotificationOverlay
  }, /*#__PURE__*/React.createElement(HeaderIcon, {
    size: "3x",
    icon: faBell
  }), userNotifications?.filter(notif => !notif.isRead).length > 0 && /*#__PURE__*/React.createElement(RedPointIcon, {
    size: "3x",
    icon: faCircle
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconContainer, {
    title: "Notifications"
  }, /*#__PURE__*/React.createElement(HeaderSvgContainer, null, /*#__PURE__*/React.createElement(HeaderIcon, {
    size: "3x",
    icon: faBell,
    onClick: props.handleNotifIconClick,
    title: "Notifications"
  })), isHasUnreadNotif && /*#__PURE__*/React.createElement(RedPointIcon, {
    size: "1x",
    icon: faCircle
  })), props.multiNotifsMenuOpened && /*#__PURE__*/React.createElement(MultiNotifsMenuContainer, null))), user && user.profile && /*#__PURE__*/React.createElement(UserMenuContainer, null, /*#__PURE__*/React.createElement(UserAccount, {
    id: "userAccountBtn",
    onClick: () => setOpenUserAccount(!openUserAccount)
  }, /*#__PURE__*/React.createElement(UserAvatar, {
    size: "3x",
    icon: faCircleUser
  }), /*#__PURE__*/React.createElement("span", null, `${user.profile.firstName} ${user.profile.lastName}`), /*#__PURE__*/React.createElement(UserArrow, {
    size: "3x",
    icon: faCaretDown
  })), openUserAccount && /*#__PURE__*/React.createElement(UserAccountMenu, {
    ref: refUserMenu
  }, /*#__PURE__*/React.createElement(UserAccountMenuTitle, null, "Mon compte"), /*#__PURE__*/React.createElement(UserAccountMenuContent, null, /*#__PURE__*/React.createElement(UserAccountMenuItem, {
    onClick: handleClickChangePassword
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faLockKeyhole
  }), /*#__PURE__*/React.createElement("span", null, "Changer de mot de passe")), /*#__PURE__*/React.createElement(UserAccountMenuItem, {
    onClick: handleLogout
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faArrowRightFromBracket
  }), /*#__PURE__*/React.createElement("span", null, "D\xE9connexion")))))), isCreateProjectPage && /*#__PURE__*/React.createElement(TitleWrapper, null, /*#__PURE__*/React.createElement(Title, null, "Cr\xE9er un nouveau projet"))), openNotificationOverlay && /*#__PURE__*/React.createElement(NotificationsContainerOverlay, {
    onClose: handleCloseNotificationOverlay,
    animation: notifOverlayAnimation
  }), openBurgerMenuOverlay && /*#__PURE__*/React.createElement(SidebarContainerOverlay, {
    onClose: handleCloseBurgerMenu,
    sales: {
      name: selectedProjectFacilitator?.firstName || selectedProjectSeller?.firstName,
      isFacilitator: !!selectedProjectFacilitator,
      phoneNumber: selectedProjectFacilitator?.phoneNumber || selectedProjectSeller?.phoneNumber
    },
    animation: burgerMenuAnimation
  }));
};
const mapStateToProps = _ref => {
  let {
    router,
    menus,
    project
  } = _ref;
  return {
    currentRoute: router.location.pathname,
    optionsMenuOpened: menus.optionsMenuOpened,
    multiNotifsMenuOpened: menus.multiNotifsMenuOpened,
    project: project.projects
  };
};
const mapDispatchToProps = dispatch => ({
  handleOptionsClick: event => {
    event.stopPropagation();
    return dispatch(toggleOptionsMenu());
  },
  handleNotifIconClick: event => {
    event.stopPropagation();
    return dispatch(toggleMultiNotifsMenu());
  }
});
ProjectHeaderView.propTypes = {
  theme: PropTypes.object.isRequired,
  currentRoute: PropTypes.string.isRequired,
  optionsMenuOpened: PropTypes.bool.isRequired,
  handleOptionsClick: PropTypes.func.isRequired,
  multiNotifsMenuOpened: PropTypes.bool.isRequired,
  handleNotifIconClick: PropTypes.func.isRequired
};
export default connect(mapStateToProps, mapDispatchToProps)(withTheme(ProjectHeaderView));